import {call, fork, put, takeEvery} from "@redux-saga/core/effects";
import {getWorkspaceByWorkspaceKeyAndAccountId} from "../../../api/permission";
import {setPermissionsTnpActionsError, setPermissionsTnpActionsSuccess} from "../../actions/permission/action";
import {permissionTnpType} from "../../actions/permission/type";


function* onLoadPermissionsAccount(params) {
    const response = yield call(getWorkspaceByWorkspaceKeyAndAccountId, params.params);
    function getValue(createValue) {
        if (createValue) {
            if (typeof createValue === "string") {
                return createValue === "true"
            }
        } else {
            return false
        }
    }

    try {

        let permissionResult = {}
        response?.subWorkspaces?.map(workspace => {
            const createValue = getValue(workspace?.create?.createValue) ;
            permissionResult = {
                ...permissionResult,
                [workspace.key]: {
                    add: createValue,
                    view : (workspace?.view?.viewValue !== undefined || workspace?.enable),
                    enable: workspace?.enable,
                    key: workspace.key
                }
            }
        });
        const permissions = {
            isAdministrator: response?.isAdministrator,
            isSystemManager: response?.isSystemManager ,
            enable: response?.enable,
            permissions: permissionResult
        }

        yield put(setPermissionsTnpActionsSuccess(permissions));
    } catch (e) {
        yield put(setPermissionsTnpActionsError(e))
    }
}

function* onLoadPermissionData() {
    yield takeEvery(permissionTnpType.LOAD_PERMISSIONS_TNP_DATA_START, onLoadPermissionsAccount)
}

const permissionsTnpData = [
    fork(onLoadPermissionData)
]

export default permissionsTnpData